import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

// ===============================
// IPA SYMBOLS
// ===============================

export const fetchIpaSymbols = async (params) => {
 try {
 const res = await api.get("/admin/ipa/symbols", { params });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch symbols" };
 }
};

export const fetchIpaSymbolById = async (id) => {
 try {
 const res = await api.get(`/admin/ipa/symbols/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch symbol" };
 }
};

export const createIpaSymbol = async (payload) => {
 try {
 const res = await api.post("/admin/ipa/symbols", payload);
 return { status: res.status, data: res.data, message: "Symbol created successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
 }
};

export const updateIpaSymbol = async (id, payload) => {
 try {
 const res = await api.put(`/admin/ipa/symbols/${id}`, payload);
 return { status: res.status, data: res.data, message: "Symbol updated successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
 }
};

export const deleteIpaSymbol = async (id) => {
 try {
 const res = await api.delete(`/admin/ipa/symbols/${id}`);
 return { status: res.status, message: "Deleted successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
 }
};

// ===============================
// IPA LESSONS
// ===============================

export const fetchIpaLessons = async (params) => {
 try {
 const res = await api.get("/admin/ipa/lessons", { params });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch lessons" };
 }
};

export const fetchIpaLessonById = async (id) => {
 try {
 const res = await api.get(`/admin/ipa/lessons/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch lesson" };
 }
};

export const createIpaLesson = async (payload) => {
 try {
 const res = await api.post("/admin/ipa/lessons", payload);
 return { status: res.status, data: res.data, message: "Lesson created successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
 }
};

export const updateIpaLesson = async (id, payload) => {
 try {
 const res = await api.put(`/admin/ipa/lessons/${id}`, payload);
 return { status: res.status, data: res.data, message: "Lesson updated successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
 }
};

export const deleteIpaLesson = async (id) => {
 try {
 const res = await api.delete(`/admin/ipa/lessons/${id}`);
 return { status: res.status, message: "Deleted successfully" };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
 }
};
